import TemplateView from '../../../../TemplateView'
import LicensedToSection from './LicensedToSection'
import PaymentMethodSection from './PaymentMethodSection'
import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import $ from 'jquery'
import _ from 'underscore'
import {getCountries, getDocumentsBaseUrl, getLicensedToInfo, getPaymentMethod, getSavedCardInfo, isFirstLoading} from '../../selectors'
import {DateFormat} from '../../../../date_format'
import {openSupportForm} from '../../../../support/supportForm/actions'
import {supportPopupPositionStrategy} from '../../../../support/supportForm/constants'

class CompanyInfoPanel extends TemplateView {
    constructor({
        openCompanyInfoEditor = () => {},
        openPaymentMethodEditor = () => {},
        openSupportForm = () => {},
    } = {}) {
        super()

        this.actions = {
            openCompanyInfoEditor,
            openPaymentMethodEditor,
            openSupportForm,
        }

        this.params = {}

        this.state = {
            firstLoading: false,
            licensedTo: {},
            paymentMethod: null,
            cardInfo: {},
            documentsBaseUrl: '',
            countries: [],
        }

        this.onStatePropertyChanged('firstLoading', (firstLoading) => {
            this.$licensedToContainer.toggle(!firstLoading)
        })

        this.onAnyStatePropertyChanged(['licensedTo', 'documentsBaseUrl'], () => {
            if (_.size(this.state.licensedTo) > 0) {
                const acceptedAgreement = !!this.state.licensedTo.serviceAgreementUrl &&
                                          !!this.state.licensedTo.dataProcessingAgreementUrl &&
                                          !!this.state.licensedTo.serviceAgreementExhibitUrl

                this.licensedToSection.setState({
                    companyName: this.state.licensedTo.name,
                    companyAddress: this._getCompanyAddress(),
                    primaryContact: this._getPrimaryContact(),
                    documentsBaseUrl: this.state.documentsBaseUrl,
                    serviceAgreementLink: this.state.licensedTo.serviceAgreementUrl,
                    dataProcessingAgreementLink: this.state.licensedTo.dataProcessingAgreementUrl,
                    exhibitLink: this.state.licensedTo.serviceAgreementExhibitUrl,
                    acceptedAgreement,
                    acceptedDate: this.dateFormat.formatDate(this.state.licensedTo.timestamp.parseJSONDate()),
                })
            }
        })

        this.onAnyStatePropertyChanged(['paymentMethod', 'firstLoading'], () => {
            this.$paymentMethodContainer.toggle(!!this.state.paymentMethod && !this.state.firstLoading)
        })

        this.onStatePropertyChanged('paymentMethod', (paymentMethod) => {
            this.paymentMethodSection.setState({paymentMethod})
        })

        this.onStatePropertyChanged('cardInfo', (cardInfo) => {
            if (_.size(cardInfo) > 0) {
                this.paymentMethodSection.setState({
                    ...cardInfo,
                    hasCardInfo: !!cardInfo
                })
            }
        })
    }

    templateHtml() {
        return "<div class='licensesCompanyInfoPanel'>" +
               "    <div class='panelHeader'><%=companyInfo%></div>" +
               "    <div class='licensedToContainer'/>" +
               "    <div class='paymentMethodContainer'/>" +
               "    <div class='contactSupportSection'>" +
               "        <div class='icon'/>" +
               "        <div class='text'><%=contactSupport%></div>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            companyInfo: 'licenses.panel.company_info',
            contactSupport: 'licenses.panel.contact_support',
        }
    }

    afterRender() {
        this.$licensedToContainer = this.find('.licensedToContainer')
        this.$paymentMethodContainer = this.find('.paymentMethodContainer')

        this.licensedToSection = new LicensedToSection({
            onEditButtonClick: this.actions.openCompanyInfoEditor,
        }).init(this.$licensedToContainer)
        this.paymentMethodSection = new PaymentMethodSection({
            onEditButtonClick: this.actions.openPaymentMethodEditor,
        }).init(this.$paymentMethodContainer)

        this.find('.contactSupportSection .text').on('click', () => this.actions.openSupportForm({
            positionStrategy: supportPopupPositionStrategy.CENTER, position: {x: 0, y: 0,},
        }))

        this.dateFormat = new DateFormat(window.SystemSettings.dateFormat)

        $(window).resizeThrottle(() => this.adjustSize(), 100)
        $(document).on("navigationResize", () => this.adjustSize())
        this.adjustSize()
    }

    adjustSize() {
        this.getEl().css('min-height', $(window).height() - this.getEl().offset().top + 'px')
    }

    _getCompanyAddress() {
        const result = [
            this.state.licensedTo.address,
            this.state.licensedTo.city,
            this.state.licensedTo.state,
            this.state.licensedTo.zip,
        ]
        if (this.state.licensedTo.country) result.push(this.state.countries.find((item) => item.code === this.state.licensedTo.country).name)
        return result.filter((elem) => elem).join(', ')
    }

    _getPrimaryContact() {
        return this.state.licensedTo.firstName + ' ' + this.state.licensedTo.lastName + ' (' + this.state.licensedTo.email + ')'
    }
}

export default connect(
    (state) => ({
        firstLoading: isFirstLoading(state),
        licensedTo: getLicensedToInfo(state),
        paymentMethod: getPaymentMethod(state),
        cardInfo: getSavedCardInfo(state),
        documentsBaseUrl: getDocumentsBaseUrl(state),
        countries: getCountries(state),
    }),
    (dispatch) => ({
        openSupportForm: bindActionCreators(openSupportForm, dispatch),
    })
)(CompanyInfoPanel)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/companyInfoPanel/CompanyInfoPanel.js